import { render } from "./PreviewDetailAgendaSubKomunitasView.vue?vue&type=template&id=7d935904"
import script from "./PreviewDetailAgendaSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./PreviewDetailAgendaSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__